import LazyLoad from "./library/LazyLoad";
import Helpers from "./library/Helpers";
import Polyfill from "./library/AssignPolyfill";
import Forms from "./components/Forms";
import Popups from "./components/Popups";
import Carousels from "./components/Carousels";
import Header from "./components/Header";
import Navigation from "./components/Navigation";
import Tabs from "./components/Tabs";
import Events from "./components/Events";
import Voucher from "./components/Voucher";
import Extras from "./Extras";
import CookiesPopup from "./components/CookiesPopup";
import $ from "jquery";

global.jQuery = global.$ = $;

$(() => {
    // Plugins
    require("./plugins/ImagesLoaded.js");
    require("./plugins/Modernizr.js");
    require("./../../node_modules/magnific-popup/dist/jquery.magnific-popup.js");
    require("./../../node_modules/slick-carousel/slick/slick.js");
    require("selectric/src/jquery.selectric.js");
    require("./library/StubConsole.js");
    require("./library/Request.js");
    //require('./library/Recaptcha.js');
    LazyLoad.init();

    Forms.init();
    Carousels.init();
    Popups.init();
    Header.init();
    Navigation.init();
    Tabs.init();
    Events.init();
    Extras.init();
    Voucher.init();
    CookiesPopup.init();
});
